import React, {useState} from "react";
import { Router } from "react-router-dom/cjs/react-router-dom.min";

// components


import CreateUserForm from "components/Form/UserCreate";

const handleUserCreation = (user) => {
    alert("Berhasil Membuat User")
  };
export default function Tables() {
  return (
    <>
    <div className="bg-gray-200 min-h-screen py-6 px-4">
      <div className="flex justify-center items-center mt-16">
      <div className="w-full md:w-1/2 max-w-7xl bg-gray-800 shadow-md rounded-lg p-4 md:p-8 mx-auto">
          <div className="flex flex-wrap">
            <div className="w-full px-4 mt-4">
              <CreateUserForm onclick={handleUserCreation} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
